<div id="legal" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="pt-4 container">
        <div class="row">
            <ul class="nav nav-tabs nav-justified md-tabs" href="#legalDoc" role="tablist" style="width: 100%; margin: 0px 0px 0px 0px;background-color: #5da4b5;">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" onclick="orgMain.showLegalDoc('pp')" role="tab">Privacy Policy</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" onclick="orgMain.showLegalDoc('tos')" role="tab">Terms of Service</a>
                </li>
            </ul>
        </div>
        <div class="row" id="legalDoc">
            <div class="col-sm-12 col-md-12 col-lg-12 popupContainer">
                <div class="row" style="border: 1px solid white;">
                    <object id="legalPage" type="text/html" data="/pp.html" height="600px" width="100%" style="overflow:auto;border:1px white">
                    </object>
                </div>
    
            </div>
        </div>
    </div>
</div>